'use strict';

(function () {
    'use strict';

    angular.module('schedules', ['schedules.closedSlot', 'schedules.planning', 'ui.router', 'common']);
})();